import { render, staticRenderFns } from "./formAssinatura.vue?vue&type=template&id=58c5e5c2&scoped=true"
import script from "./formAssinatura.vue?vue&type=script&lang=js"
export * from "./formAssinatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c5e5c2",
  null
  
)

export default component.exports